import events from 'events'
const MAX_LISTENERS = 100;
!function (root, factory) {
    root = root || {};
    if (!root.eventLib) {
        root.eventLib = factory();
    }
    if (typeof module === 'object' && module.exports) {
        module.exports = root.eventLib;
    }
    root.eventLib.setMaxListeners(MAX_LISTENERS);
}(typeof window !== 'undefined' ? window : this, function () {
    return new events.EventEmitter();
});


// WEBPACK FOOTER //
// ./src/libs/eventLib.js